import React, { Component } from 'react'
import { Card, Typography, message, Divider, Alert, Switch, Tag } from 'antd'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import storageUtils from '../../utils/storageUtils'
import { req_edit_slm_survey } from '../../api'
import { formateDate } from '../../utils/dateUtil'

import PicturesWall from './pictures-wall'
const { Title, Text } = Typography;
class ConfirmInstructorModal extends Component {
    // 基礎通用參數 //////////////////////////////////////////////       
    static propTypes = {
        student: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        agreePrivacy: true,
        item: {},
        isMyhouse: false,
        isDorm: false,
        isStay: false,
        isContract: false,
        isIntern: false,
        dormRoomCode: 'NONE',
        temp: {
            LiveType: 'NONE',
            LiveAddress: '',
            LiveCaseNid: -9,
        },
        description: '',
    }

    constructor(props) {
        super(props)

        //獲取子組件(pictures-wall)實體方法
        this.get_images = React.createRef()

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAgree = this.handleAgree.bind(this);
        this.handleDisagree = this.handleDisagree.bind(this);
        this.handle_ui_switch_process = this.handle_ui_switch_process.bind(this);

    }

    UNSAFE_componentWillMount() {
        this.api_single_item()
    }

    componentDidMount() {

    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_item = async () => {
    }

    api_edit_item = async (item) => {
        const result = await req_edit_slm_survey(item, storageUtils.getUser().token)
        if (result.status === "success") {
            // console.log(result)
            message.success('填報完成')
            this.api_single_item()
        } else {
            message.error(result.message)
        }
    }

    /////////////////////////////////////////////////////////// 

    handleChange(event) {
        const { item } = this.state
        //console.log(event)
        Object.keys(item).forEach(propertyName => {
            if (event.target.id === 'agreePrivacy' && event.target.value !== null) {
                // Checkbox
                const agreePrivacy = event.target.checked
                this.setState({ agreePrivacy })
            } else {
                if (event.target.id === propertyName && event.target.value !== null) {
                    item[propertyName] = event.target.value.trim()
                }
            }
        });
        this.setState({ item })
    }

    handleSubmit(event) {
        event.preventDefault()
        const row = this.props.student
        const images = this.get_images.current.output_files()
        const AppendixLiveCases = images.reduce((item_pre, item) => {
            item_pre.push({ Uid: item })
            return item_pre
        }, [])
        const errors = []

        // 1.數據檢核
        row.AppendixLiveCases = AppendixLiveCases
        if (errors.length === 0) {
            // console.log(row)
            // 2.數據整理
            row.condition = 'INSTRUCTOR'
            this.api_edit_item(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }

    handleAgree() {
        const agreePrivacy = true
        this.setState({ agreePrivacy })
    }

    handleDisagree() {
        const agreePrivacy = false
        this.setState({ agreePrivacy })
    }

    handle_ui_switch_process(field, e) {
        const item = this.props.student
        const value = (e === false) ? 1 : 0
        switch (field) {
            case 'SA01':
                item.SA01 = value
                break
            case 'SA02':
                item.SA02 = value
                break
            case 'SA03':
                item.SA03 = value
                break
            case 'SA04':
                item.SA04 = value
                break
            case 'SA05':
                item.SA05 = value
                break
            case 'SA06':
                item.SA06 = value
                break
            case 'SA07':
                item.SA07 = value
                break
            case 'SB08':
                item.SB08 = value
                break
            case 'SB09':
                item.SB09 = value
                break
            case 'SB10':
                item.SB10 = value
                break
            case 'SB11':
                item.SB11 = value
                break    
            case 'SC11':
                item.SC11 = value
                break
            case 'SC12':
                item.SC12 = value
                break
            case 'SC13':
                item.SC13 = value
                break
            case 'SC14':
                item.SC14 = value
                break
            case 'SD01':
                item.SD01 = value
                break  
            case 'TA01':
                item.TA01 = value
                break
            case 'TA02':
                item.TA02 = value
                break
            case 'TA03':
                item.TA03 = value
                break
            case 'TA04':
                item.TA04 = value
                break
            case 'TA05':
                item.TA05 = value
                break
            case 'TA06':
                item.TA06 = value
                break
            case 'TA07':
                item.TA07 = value
                break
            case 'TB08':
                item.TB08 = value
                break
            case 'TB09':
                item.TB09 = value
                break
            case 'TB10':
                item.TB10 = value
                break
            case 'TB11':
                item.TB11 = value
                break    
            case 'TC11':
                item.TC11 = value
                break
            case 'TC12':
                item.TC12 = value
                break
            case 'TC13':
                item.TC13 = value
                break
            case 'TD01':
                item.TD01 = value
                break
            case 'IA01':
                item.IA01 = value
                break
            case 'IA02':
                item.IA02 = value
                break
            case 'IA03':
                item.IA03 = value
                break
            case 'IA04':
                item.IA04 = value
                break
            case 'IA05':
                item.IA05 = value
                break
            case 'IA06':
                item.IA06 = value
                break
            case 'IA07':
                item.IA07 = value
                break
            case 'IB08':
                item.IB08 = value
                break
            case 'IB09':
                item.IB09 = value
                break
            case 'IB10':
                item.IB10 = value
                break
            case 'IB11':
                item.IB11 = value
                break    
            case 'IC11':
                item.IC11 = value
                break
            case 'IC12':
                item.IC12 = value
                break
            case 'IC13':
                item.IC13 = value
                break
            case 'ID01':
                item.ID01 = value
                break
            default:
        }
        this.setState({ item })
 
        // console.log(item)
    }

    /////////////////////////////
    render() {
        const { LiveAddress, HouseOwnerName, HouseOwnerPhone, DepartmentTwName, ClassroomTwName, StudentId, TwName, TutorCheckDateTime, TutorDescription, InstructorDescription, AppendixLiveCases,
            SA01, SA02, SA03, SA04, SA05, SA06, SA07, SB08, SB09, SB10, SB11, SC11, SC12, SC13, SC14, SD01, TA01, TA02, TA03, TA04, TA05, TA06, TA07, TB08, TB09, TB10, TB11, TC11, TC12, TC13, TD01, IA01, IA02, IA03, IA04, IA05, IA06, IA07, IB08, IB09, IB10, IB11, IC11, IC12, IC13, ID01,
        } = this.props.student
        return (
            <form onSubmit={this.handleSubmit}>
                <Card>
                    <div className="form-row">
                        <div className="form-group form-check">
                            <Title level={5}><Text type="danger"><i className="fas fa-user-tag"></i> {DepartmentTwName} / {ClassroomTwName} / {TwName} ({StudentId})</Text></Title>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg-6">
                            <div className="form-group">
                                <label>賃居地址</label>
                                <input type="text" className="form-control text-primary" name="LiveAddress" id="LiveAddress" aria-describedby="mobileHelp" placeholder="請輸入您目前賃居地址" defaultValue={LiveAddress} onChange={this.handleChange} disabled={true} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>出租者姓名</label>
                                <input type="text" className="form-control text-primary" name="HouseOwnerName" id="HouseOwnerName" aria-describedby="mobileHelp" placeholder="請輸入出租者姓名" defaultValue={HouseOwnerName} onChange={this.handleChange} disabled={true} />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="form-group">
                                <label>出租者電話</label>
                                <input type="text" className="form-control text-primary" name="HouseOwnerPhone" id="HouseOwnerPhone" aria-describedby="mobileHelp" placeholder="請輸入出租者電話" defaultValue={HouseOwnerPhone} onChange={this.handleChange} disabled={true} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <Alert message="學生自評結果" type="error" showIcon />
                                {SA01 === 1 ? (<Tag color="volcano">採用木造隔間套房(雅房)或鐵皮加蓋</Tag>) : ''}
                                {SA02 === 1 ? (<Tag color="volcano">將多種電器同時插在同一條延長線上</Tag>) : ''}
                                {SA03 === 1 ? (<Tag color="volcano">房間內未裝設火警自動警報器(偵煙器)</Tag>) : ''}
                                {SA04 === 1 ? (<Tag color="volcano">未設置滅火器指針在綠色區(或效期三年)</Tag>) : ''}
                                {SA05 === 1 ? (<Tag color="volcano">逃生通道(未標示)暢通(不清楚)或寬未達75cm</Tag>) : ''}
                                {SA06 === 1 ? (<Tag color="volcano">未設置電熱水器或強制排氣瓦斯熱水器</Tag>) : ''}
                                {SA07 === 1 ? (<Tag color="volcano">建築物不具有鎖具或門禁管理措施</Tag>) : ''}
                                {SB08 === 1 ? (<Tag color="volcano">為大型租賃處所但未辦理公安申報效期2年（或4年）</Tag>) : ''}
                                {SB09 === 1 ? (<Tag color="volcano">建築物內或周邊未裝設監視器設備</Tag>) : ''}
                                {SB10 === 1 ? (<Tag color="volcano">停車場所暗黑不安全</Tag>) : ''}
                                {SB11 === 1 ? (<Tag color="volcano">通勤上下學路線不安全</Tag>) : ''}
                                {SC11 === 1 ? (<Tag color="volcano">不瞭解用電安全常識</Tag>) : ''}
                                {SC12 === 1 ? (<Tag color="volcano">不熟稔住所逃生通道及逃生要領</Tag>) : ''}
                                {SC13 === 1 ? (<Tag color="volcano">不知使用內政部最新『住宅租賃契約書』</Tag>) : ''}
                                {SC14 === 1 ? (<Tag color="volcano">不知鄰近派出所、消防隊、醫療院所及學校校安專線聯繫電話</Tag>) : ''}
                                {SD01 === 1 ? (<Tag color="volcano">未申請政府租金補貼</Tag>) : ''}
                            </div>
                        </div>
                    </div>
                    {formateDate(TutorCheckDateTime) !== '1999-1-1 00:00:00' ? (<div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <Alert message="導師訪視結果" type="error" showIcon />
                                {TA01 === 1 ? (<Tag color="volcano">採用木造隔間套房(雅房)或鐵皮加蓋</Tag>) : ''}
                                {TA02 === 1 ? (<Tag color="volcano">將多種電器同時插在同一條延長線上</Tag>) : ''}
                                {TA03 === 1 ? (<Tag color="volcano">房間內未裝設火警自動警報器(偵煙器)</Tag>) : ''}
                                {TA04 === 1 ? (<Tag color="volcano">未設置滅火器指針在綠色區(或效期三年)</Tag>) : ''}
                                {TA05 === 1 ? (<Tag color="volcano">逃生通道(未標示)暢通(不清楚)或寬未達75cm</Tag>) : ''}
                                {TA06 === 1 ? (<Tag color="volcano">未設置電熱水器或強制排氣瓦斯熱水器</Tag>) : ''}
                                {TA07 === 1 ? (<Tag color="volcano">建築物不具有鎖具或門禁管理措施</Tag>) : ''}
                                {TB08 === 1 ? (<Tag color="volcano">為大型租賃處所但未辦理公安申報效期2年（或4年）</Tag>) : ''}
                                {TB09 === 1 ? (<Tag color="volcano">建築物內或周邊未裝設監視器設備</Tag>) : ''}
                                {TB10 === 1 ? (<Tag color="volcano">停車場所暗黑不安全</Tag>) : ''}
                                {TB11 === 1 ? (<Tag color="volcano">通勤上下學路線不安全</Tag>) : ''}
                                {TC11 === 1 ? (<Tag color="volcano">學生不瞭解用電安全常識</Tag>) : ''}
                                {TC12 === 1 ? (<Tag color="volcano">學生不熟稔住所逃生通道及逃生要領</Tag>) : ''}
                                {TC13 === 1 ? (<Tag color="volcano">學生不知使用內政部最新『住宅租賃契約書』</Tag>) : ''}
                                {TD01 === 1 ? (<Tag color="volcano">學生未申請政府租金補貼</Tag>) : ''}
                                {TutorDescription ? (<input type="text" className="form-control text-primary" name="TutorDescription" id="TutorDescription" aria-describedby="mobileHelp" placeholder="補充所見事實...." defaultValue={TutorDescription} onChange={this.handleChange} disabled={true} />) : ''}
                                
                            </div>
                        </div>
                    </div>) : ''}
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <Alert message="請您檢核以下項目" type="warning" showIcon />
                                <Divider orientation="left" plain>A.安全項目</Divider>
                                <Switch checkedChildren="非採用木造隔間套房(雅房)或鐵皮加蓋" unCheckedChildren="採用木造隔間套房(雅房)或鐵皮加蓋" defaultChecked={IA01 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA01', e)} />
                                <Switch checkedChildren="未將多種電器同時插在同一條延長線上" unCheckedChildren="將多種電器同時插在同一條延長線上" defaultChecked={IA02 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA02', e)} />
                                <Switch checkedChildren="房間內有裝設火警自動警報器(偵煙器)" unCheckedChildren="房間內未裝設火警自動警報器(偵煙器)" defaultChecked={IA03 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA03', e)} />
                                <Switch checkedChildren="有設置滅火器指針在綠色區(或效期三年)" unCheckedChildren="未設置滅火器指針在綠色區(或效期三年)" defaultChecked={IA04 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA04', e)} />
                                <Switch checkedChildren="逃生通道(標示)暢通(清楚)或寬達75cm" unCheckedChildren="逃生通道(未標示)暢通(不清楚)或寬未達75cm" defaultChecked={IA05 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA05', e)} />
                                <Switch checkedChildren="有設置電熱水器或強制排氣瓦斯熱水器" unCheckedChildren="未設置電熱水器或強制排氣瓦斯熱水器" defaultChecked={IA06 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA06', e)} />
                                <Switch checkedChildren="建築物具有鎖具或門禁管理措施" unCheckedChildren="建築物不具有鎖具或門禁管理措施" defaultChecked={IA07 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IA07', e)} />
                                <Divider orientation="left" plain>B.輔助項目</Divider>
                                <Switch checkedChildren="為大型租賃處所且有辦理公安申報效期2年（或4年）" unCheckedChildren="為大型租賃處所但未辦理公安申報效期2年（或4年）" defaultChecked={IB08 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IB08', e)} />
                                <Switch checkedChildren="建築物內或周邊有裝設監視器設備" unCheckedChildren="建築物內或周邊未裝設監視器設備" defaultChecked={IB09 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IB09', e)} />
                                <Switch checkedChildren="停車場所明亮安全" unCheckedChildren="停車場所暗黑不安全" defaultChecked={IB10 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IB10', e)} />
                                <Switch checkedChildren="通勤上下學路線安全" unCheckedChildren="通勤上下學路線不安全" defaultChecked={IB11 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IB11', e)} />    
                                <Divider orientation="left" plain>C.宣導項目</Divider>
                                <Switch checkedChildren="學生瞭解用電安全常識" unCheckedChildren="學生不瞭解用電安全常識" defaultChecked={IC11 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IC11', e)} />
                                <Switch checkedChildren="學生熟稔住所逃生通道及逃生要領" unCheckedChildren="學生不熟稔住所逃生通道及逃生要領" defaultChecked={IC12 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IC12', e)} />
                                <Switch checkedChildren="學生知悉使用內政部最新『住宅租賃契約書』" unCheckedChildren="學生不知使用內政部最新『住宅租賃契約書』" defaultChecked={IC13 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('IC13', e)} />
                                <Divider orientation="left" plain>D.申請項目</Divider>
                                <Switch checkedChildren="學生申請政府租金補貼" unCheckedChildren="學生未申請政府租金補貼" defaultChecked={ID01 === 0 ? true : false} onChange={(e) => this.handle_ui_switch_process('ID01', e)} />
                                <Divider orientation="left" plain>E.佐證照片</Divider>
                                <PicturesWall ref={this.get_images} images_source={AppendixLiveCases} api_url="/api/AppendixLiveCase/AddFile"></PicturesWall>
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label>補充說明</label>
                                <input type="text" className="form-control text-primary" name="InstructorDescription" id="InstructorDescription" aria-describedby="mobileHelp" placeholder="補充所見事實...." defaultValue={InstructorDescription} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                {formateDate(TutorCheckDateTime) === '1999-1-1 00:00:00' ?
                                    (<div className="form-row">
                                        <input type="submit" value="送出檢核單" className="btn btn-danger btn-sm btn-block" />
                                    </div>) : (<div className="form-row">
                                        <input type="submit" value="變更檢核單" className="btn btn-danger btn-sm btn-block" />
                                    </div>)}
                            </div>
                        </div>
                    </div>
                </Card>
            </form >
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ConfirmInstructorModal)